import CopyToClipboard from 'react-copy-to-clipboard'
import { Icon, Input, Button } from '@driftt/tide-core-legacy'

import './style.styl'


const Unsubscription = ({
  unsubLink,
  onEndUserEmailChange,
  endUserEmail,
  handleCopyUnsubLink,
  isCopied,
}) => (
  <div className="conversation-settings-unsubscribe-link">
    <h3>Create an unsubscribe link</h3>
    <label>Enter the user’s email</label>
    <div className="conversation-settings-email-input-helptext">(optional, this is used to pre-fill the email text box for your users)</div>
    <Input className="conversation-unsubscribe-email-input" placeholder="email" onChange={onEndUserEmailChange} value={endUserEmail} />
    <CopyToClipboard text={unsubLink} onCopy={handleCopyUnsubLink}>
      <Button type="primary">
        <Icon width={12} name="link-1" />{' '}
        {isCopied ? 'Copied!' : 'Copy Unsubscribe Link'}
      </Button>
    </CopyToClipboard>
  </div>
)


export default Unsubscription



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Unsubscription/component.js